require.register("app/product/stat/AverageSupplierPriceView", function(exports, require, module){
  $0
  
});

